import { TextFieldFormsy } from '@fuse/core/formsy';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
// import * as authActions from 'app/auth/store/actions';
import Formsy from 'formsy-react';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import { ToastContainer, toast } from 'react-toastify';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import axios from 'axios';
import * as API from 'app/constants/ApiConstants';
import * as APP from 'app/constants/AppConstants';
import aes256 from 'aes256';
import './login.css';
/* Commenting the following code for Istiyak using AI Agent. September 17, 2026. Comment Start */
/* import { trackRecruiterAction } from 'app/services/recruiterapi/ManageJobAPI/managejobAPI'; */
/* Commenting end. Istiyak using AI Agent. September 17, 2026 */
/* Added the following code for POW-902.Harsha using AI Agent. August 19, 2026. Code Start */
import { getDefaultLandingRoute } from 'app/utils/defaultPageUtils';
/* Code end. Harsha using AI Agent. August 19, 2026 */

function FirebaseLoginTab(props) {
	// const dispatch = useDispatch();
	const login = useSelector(({ auth }) => auth.login);
	const user = useSelector(({ auth }) => auth.user);
	const [getkey, setKey] = useState("prja2021cG93ZXJyZWNydWl0MjAyMA==");
	const [isFormValid, setIsFormValid] = useState(false);
	const [message, errorFunction] = useState(false);
	const formRef = useRef(null);
	const history = useHistory()
	
	useEffect(() => {


		
		// if (login.error && (login.error.erroMessage)) {
		// 	errorFunction(true)
		// 	disableButton();
		// }
		// else {
		// 	errorFunction(false)
		// }

		// //PAGE ASSIGN --------------------------------------------------------------------------------------
		// if (user.userRole) {
		// 	let localdata = {
		// 		"roleId": user.userRole
		// 	}
		// 	localStorage.setItem('Role', user.userRole)
		// 	// dispatch(authActions.PageAssignActions(localdata))

		// 	// authActions.PageAssignActions(localdata, res => {
		// 	// 	let pageassignArr = []
		// 	// 	if (res) {
		// 	// 		res.map((item) => {
		// 	// 			pageassignArr.push(item.pageId)
		// 	// 		})
		// 	// 		localStorage.setItem("Page", pageassignArr.toString())
		// 	// 	}
		// 	// 	else if (res.length == 0) {
		// 	// 		history.push('/')
		// 	// 	}
		// 	// })
		// }
		// --------------------------------------------------------------------------------------------------
		// if (user.userRole == 1) {
		// 	history.push("/dashboard/dashboard")
		// 	window.location.reload()
		// }
		// else if (user.userRole == 2) {
		// 	history.push("/dashboard/analytics")
		// 	window.location.reload()
		// }
		// else if (user.userRole == 4) {
		// 	history.push("/dashboard/teamlead/analytics")
		// 	window.location.reload()
		// }
		// else {
		// 	history.push("/")
		// }
	}, [login.error, user]);

	
	function disableButton() {
		setIsFormValid(false);
	}

	function enableButton() {
		setIsFormValid(true);
	}

	function setSession(authResult) {
		if (authResult && authResult.accessToken && authResult.idToken) {
			// Set the time that the access token will expire at
			const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
			localStorage.setItem('access_token', authResult.accessToken);
			localStorage.setItem('id_token', authResult.idToken);
			localStorage.setItem('expires_at', expiresAt);
			
		}
	};

	function callCheck() {
		if (localStorage.getItem('Page')) {
			history.push("/dashboard")
		}
	}





	function handleSubmit(model, props) {
		if (model.usename !== "teamlead" && model.password !== "teamlead@123") {
			var decrypted = values.password;
			var crypto = require('crypto')
			var key = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
			var cc = crypto.createCipher('aes-128-ecb', new Buffer(key));
			var encrypted = Buffer.concat([cc.update(decrypted, 'utf8'), cc.final()]).toString('base64');

			let data = {
				"username": model.username,
				"password": encrypted,
				 "phno" :props.phno,
				
			}

			// var cipher = aes256.createCipher(getkey)
			// var encrypted = cipher.encrypt(values.password)
			// var decrypted = cipher.decrypt(encrypted)
			// dispatch(authActions.submitLogin(data))
			return new Promise((resolve, reject) => {
				/* Added the following code for POW-902.Harsha using AI Agent. August 22, 2026. Code Start */
				axios.post(API.LOGIN_URL, data)
				/* Code end. Harsha using AI Agent. August 22, 2026 */
				/* Commenting the following code for POW-902.Harsha using AI Agent. August 22, 2026. Comment Start */
				// axios.post(API.LOCAL_AUTH_URL, data)
				/* Commenting end. Harsha using AI Agent. August 22, 2026 */
					.then(response => {
						if (response.status === APP.SUCCESS) {
							localStorage.setItem("Role", response.data.userRole)
							localStorage.setItem("Name", response.data.name)
							localStorage.setItem("UserName", response.data.username)
							localStorage.setItem("userPhoneNumber", response.data.phno)
							/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
							localStorage.setItem("userType", "recruiter")
							localStorage.removeItem("candidateEmail")
							localStorage.removeItem("candidateName")
							localStorage.removeItem("candidateBusinessId")
							localStorage.removeItem("candidateCountry")
							localStorage.removeItem("candidatePhone")
							localStorage.removeItem("candidateCity")
							localStorage.removeItem("candidateState")
							/* Code end. Harsha using AI Agent. July 9, 2026 */
							
							localStorage.setItem("Page", response.data.pages.toString())
							localStorage.setItem("buid", response.data.activeBu)
							localStorage.setItem("Write", response.data.write)
							/* Added the following code for POW-902.Harsha using AI Agent. August 19, 2026. Code Start */
							if (response.data.activeBu) {
								localStorage.setItem("activatedBUs", response.data.activeBu)
							}
							if (response.data.defaultPageId != null && response.data.defaultPageId !== 0) {
								localStorage.setItem("defaultPageId", String(response.data.defaultPageId))
							} else {
								localStorage.removeItem("defaultPageId")
								localStorage.removeItem("defaultPageUrl")
							}
							/* Code end. Harsha using AI Agent. August 19, 2026 */
							setSession(response.data.token)
							localStorage.setItem('bearer_token', response.data.token)

								
							// localStorage.setItem('bearer_token', "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6MTYxMTI1MjcxMiwiaWF0IjoxNjExMjQ1NTEyfQ.XgGa1Obi8DN-Z-zPdbMKR_8Kdo__ZhMkiafuQVDr2vf7xM6ozCREvl_17ODNXCYoKVq_YEidyW8Krt3_V5Jdnw")
							axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`
							/* Commenting the following code for Istiyak using AI Agent. September 17, 2026. Comment Start */
							/*
							trackRecruiterAction({
								action: API.RECRUITER_ACTIONS.LOGIN,
								username: response.data.username || model.username
							});
							*/
							/* Commenting end. Istiyak using AI Agent. September 17, 2026 */
						
						/* Added the following code for POW-902.Harsha using AI Agent. August 19, 2026. Code Start */
							history.push(getDefaultLandingRoute(response.data.pages, response.data.defaultPageId))
						/* Code end. Harsha using AI Agent. August 19, 2026 */
						/* Commenting the following code for POW-902.Harsha using AI Agent. August 19, 2026. Comment Start */
						// Added this code for  POW-492. Anand. July 10 2023.. Code Start /		
							// if (response.data.pages.split(",").includes("23")) {
						// Added this code for  POW-492. Anand. July 10 2023.. Code End /		
								// history.push("/analyticsdashboard")
							// }
						// Added this code for  POW-492. Anand. July 10 2023.. Code Start /		
							// else if (response.data.pages.split(",").includes("24")) {
						// Added this code for  POW-492. Anand. July 10 2023.. Code End /		
								// history.push("/recruiter/dashboard")
							// }
						// Added this code for  POW-492. Anand. July 10 2023.. Code Start /		
							// else if (response.data.pages.split(",").includes("25")) {
						// Added this code for  POW-492. Anand. July 10 2023.. Code End /		
								// history.push("/teamlead/dashboard")
							// }
							// else {
								// history.push("/")
							// }
						/* Commenting end. Harsha using AI Agent. August 19, 2026 */
						} else {
							console.log("error")
							// reject(response.data.error);
						}
					},

					
						(error) => {
							/* Added the following code for POW-902.Harsha using AI Agent. August 22, 2026. Code Start */
							const message = (error.response && error.response.data && error.response.data.erroMessage)
								? error.response.data.erroMessage
								: (error.message === 'Network Error'
									? 'Cannot reach login server. Please try again.'
									: 'Login failed. Please try again.');
							toast(message, {
								position: toast.POSITION.TOP_CENTER,
								className: 'foo-bar'
							});
							/* Code end. Harsha using AI Agent. August 22, 2026 */
							/* Commenting the following code for POW-902.Harsha using AI Agent. August 22, 2026. Comment Start */
							// toast(error.response.data.erroMessage, {
							// 	position: toast.POSITION.TOP_CENTER,
							// 	className: 'foo-bar'
							// });
							/* Commenting end. Harsha using AI Agent. August 22, 2026 */
						}
					)
			})
		}
	}
	// password
	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const [values, setValues] = React.useState({
		amount: '',
		password: '',
		weight: '',
		weightRange: '',
		showPassword: false,
	});
	const handleChange = (prop) => (event) => {
		errorFunction(false)
		setIsFormValid(true)
		setValues({ ...values, [prop]: event.target.value });
	};
	return (
		<div className="w-full">
			<ToastContainer />
			<Formsy
				onValidSubmit={handleSubmit}
				onValid={enableButton}
				onInvalid={disableButton}
				ref={formRef}
				className="flex flex-col justify-center w-full"
			>
				<TextFieldFormsy
					style={{ width: '81%', marginBottom: "1.6rem !important", padding: "18.5px 14px !important" }}
					className="mb-16"
					type="text"
					name="username"
					label="Username"
					validations={{ minLength: 4 }}
					validationErrors={{ minLength: 'Min character length is 4' }}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<PermIdentityIcon color="action">
									{/* email */}
								</PermIdentityIcon>
							</InputAdornment>
						)
					}}
					variant="outlined"
					required
				/>

				<FormControl variant="outlined" style={{ marginTop: "10px" }}>
					<InputLabel htmlFor="outlined-adornment-password">Password*</InputLabel>
					<OutlinedInput
						id="outlined-adornment-password"
						type={values.showPassword ? 'text' : 'password'}
						value={values.password}
						onChange={handleChange('password')}
						validations={{
							minLength: 3
						}}
						validationErrors={{
							minLength: 'Min character length is 3'
						}}
						endAdornment={
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									onMouseDown={handleMouseDownPassword}
									edge="end"
									style={{ padding: '7px' }}
								>
									{values.showPassword ? <Visibility /> : <VisibilityOff />}
								</IconButton>
							</InputAdornment>

						}
						labelWidth={70}
					/>
				</FormControl>

				{message === true && !user.userRole ?
					<Alert severity="error">{login.error.erroMessage}</Alert>
					: ''
				}
				<Button
					type="submit"
					variant="contained"
					color="primary"
					className="w-full mx-auto normal-case mt-16"
					aria-label="LOG IN"
					disabled={!isFormValid}
					value="firebase"
				// onClick={handleSubmit}
				>
					Log in
				</Button>

			</Formsy>
		</div>
	);
}

export default FirebaseLoginTab;
